module.exports = "/_next/static/images/card-virtual-04-0e43916623b03c493f2e053a1bdd9027.svg";